import * as Sentry from '@sentry/nextjs';
import type { SeverityLevel } from '@sentry/nextjs';

const SEVERITY_MAP: Record<string, SeverityLevel> = {
  info: 'info',
  warning: 'warning',
  error: 'error',
};

export function captureError(
  error: Error,
  options?: {
    context?: string;
    severity?: 'info' | 'warning' | 'error';
    metadata?: Record<string, unknown>;
    fingerprint?: string[];
    tags?: Record<string, string>;
  },
): void {
  Sentry.withScope(scope => {
    if (options?.severity) {
      scope.setLevel(SEVERITY_MAP[options.severity] ?? 'error');
    }
    if (options?.context) {
      scope.setTransactionName(options.context);
      scope.setTag('context', options.context);
    }
    if (options?.metadata) {
      scope.setContext('metadata', options.metadata);
    }
    if (options?.fingerprint) {
      scope.setFingerprint(options.fingerprint);
    }
    if (options?.tags) {
      for (const [key, value] of Object.entries(options.tags)) {
        scope.setTag(key, value);
      }
    }
    Sentry.captureException(error);
  });
}

export function setUser(user?: { id?: string; email?: string; username?: string }): void {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email, username: user.username });
  } else {
    Sentry.setUser(null);
  }
}
